// LIBRARIES
// @ts-nocheck
import styled from "styled-components";

// MISC
import { COLORS, BOXSHADOW, FONTS, WIDTH } from "constants/styleVariables";
import LoginPicture from "../../assets/LoginAssets/BACKGROUND.png";

export const AccountDeletionContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100vh;
  background-size: cover;
  background-image: url(${LoginPicture});
  background-color: #EBEBEB;
  overflow-x: hidden;
  overflow-y: auto;
  
  @media (${WIDTH.tabletWidth}) {
    margin-left: 0;
    justify-content: center;
    padding: 20px;
  }
  
  @media (max-width: 768px) {
    margin-left: 0;
    padding: 16px;
    background-position: center;
  }
`;

export const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  max-width: 500px;
  min-height: 600px;
  padding: 60px 40px;
  background: #F5F5F5;
  border-radius: 25px;
  opacity: 1;
  overflow-x: hidden;
  overflow-y: auto;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  
  @media (${WIDTH.tabletWidth}) {
    max-width: 90%;
    padding: 40px 30px;
    border-radius: 20px;
    min-height: auto;
  }
  
  @media (max-width: 768px) {
    max-width: 100%;
    padding: 30px 20px;
    border-radius: 15px;
    margin: 0;
    min-height: auto;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  }
  
  @media (max-width: 480px) {
    padding: 24px 16px;
    border-radius: 12px;
  }
`;

export const SupIconImage = styled.img`
  width: 160px;
  height: 160px;
  margin-bottom: 40px;
  
  @media (${WIDTH.tabletWidth}) {
    width: 120px;
    height: 120px;
    margin-bottom: 30px;
  }
  
  @media (max-width: 480px) {
    width: 100px;
    height: 100px;
    margin-bottom: 24px;
  }
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  flex: 1;
  gap: 32px;
  
  @media (${WIDTH.tabletWidth}) {
    gap: 24px;
  }
  
  @media (max-width: 480px) {
    gap: 20px;
  }
`;

export const CenteredElementsContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  max-width: 400px;
  gap: 24px;
  
  @media (${WIDTH.tabletWidth}) {
    max-width: 100%;
    gap: 20px;
  }
  
  @media (max-width: 480px) {
    gap: 16px;
  }
`;

export const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  gap: 8px;
`;

export const Title = styled.h1`
  font-family: ${FONTS.primaryFont};
  font-size: 32px;
  font-weight: 600;
  color: ${COLORS.text};
  text-align: center;
  margin: 0 0 16px 0;
  width: 100%;
  
  @media (${WIDTH.tabletWidth}) {
    font-size: 28px;
    margin: 0 0 12px 0;
  }
  
  @media (max-width: 480px) {
    font-size: 24px;
    margin: 0 0 8px 0;
  }
`;

export const Subtitle = styled.p`
  font-family: ${FONTS.primaryFont};
  font-size: 16px;
  font-weight: 400;
  color: ${COLORS.textSecondary};
  text-align: center;
  margin: 0 0 32px 0;
  line-height: 1.5;
  width: 100%;
  max-width: 400px;
  
  @media (${WIDTH.tabletWidth}) {
    font-size: 15px;
    margin: 0 0 24px 0;
    max-width: 100%;
  }
  
  @media (max-width: 480px) {
    font-size: 14px;
    margin: 0 0 20px 0;
    line-height: 1.4;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  max-width: 400px;
  gap: 16px;
  
  @media (${WIDTH.tabletWidth}) {
    max-width: 100%;
    gap: 12px;
  }
  
  @media (max-width: 480px) {
    gap: 12px;
  }
`;

export const ErrorMessage = styled.p`
  font-family: ${FONTS.primaryFont};
  font-size: 14px;
  font-weight: 400;
  color: #ff4444;
  text-align: center;
  margin: 16px 0 0 0;
  width: 100%;
  
  @media (max-width: 480px) {
    font-size: 13px;
    margin: 12px 0 0 0;
  }
`;

export const SuccessMessage = styled.p`
  font-family: ${FONTS.primaryFont};
  font-size: 14px;
  font-weight: 400;
  color: #44ff44;
  text-align: center;
  margin: 16px 0 0 0;
  width: 100%;
  
  @media (max-width: 480px) {
    font-size: 13px;
    margin: 12px 0 0 0;
  }
`;

export const BackButton = styled.button`
  background: transparent;
  border: none;
  color: ${COLORS.primary};
  font-family: ${FONTS.primaryFont};
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  text-decoration: underline;
  padding: 8px 16px;
  text-align: center;
  
  &:hover {
    opacity: 0.8;
  }
  
  @media (max-width: 480px) {
    font-size: 13px;
    padding: 8px 12px;
  }
`;

export const StepIndicator = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 24px;
  width: 100%;
  
  @media (${WIDTH.tabletWidth}) {
    margin-bottom: 20px;
  }
  
  @media (max-width: 480px) {
    margin-bottom: 16px;
  }
`;

export const StepText = styled.p`
  font-family: ${FONTS.primaryFont};
  font-size: 12px;
  font-weight: 400;
  color: ${COLORS.textSecondary};
  margin: 0;
  text-transform: uppercase;
  letter-spacing: 1px;
  text-align: center;
  
  @media (max-width: 480px) {
    font-size: 11px;
    letter-spacing: 0.5px;
  }
`;